import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type FreightForwarderRecord = QueryAtomResult<
  typeof freightForwardersQueryAtom
>['freightForwarders'][number];

export const freightForwardersQueryAtom = createQueryAtomFactory(
  'trade.freightForwarders',
  (params?: { searchTerm?: string; facilityIds?: string[] }) => ({
    freightForwarders: {
      __args: {
        filter: {
          ...(params?.searchTerm && { searchTerm: params.searchTerm }),
          ...(params?.facilityIds && { facilityIds: params.facilityIds }),
        },
        pagination: {
          offset: 0,
          limit: 200,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data) => ({
      freightForwarders:
        data?.freightForwarders.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
        })) ?? [],
    }),
  },
);
